import React, { Component } from 'react'
import FixedView from '../FixedView'
import StagesManager from '../StagesManager'
import IntractionActionsList from '../IntractionActionsList'
import { checkPermission, checkTranslation, translate } from '../../utils/useful'
import GroupedBy from '../inputs/GroupedBy'
import importedIcons from '../inputs/icons'
import { MenuBuilderObjects } from '../../variables/menuBuilderData'

export default class MenuMainItem extends Component {

  state = {
    stages: []
  }

  componentDidMount = () => {

    this.init()

  }

  componentDidUpdate(prevProps) {

    if (prevProps.list != this.props.list || prevProps.item != this.props.item) {
      this.init()
    }
  }

  init = () => {

    let item = this.props.item

    if (item.type == 'dropdown') {
      let stages = []

      let list = this.props.list
      this.findAllDropdowns(list, item._id, stages)

      this.setState({ stages, showStages: false }, () => {
        this.setState({ showStages: true })
      })

    }
  }


  findAllDropdowns = (list, id, stages) => {

    let myData = list.filter((a) => (a.parents.includes(id) && a.type == 'dropdown'))

    if (Array.isArray(myData) && myData.length > 0) {

      // console.log(myData, stages)
      // stages = [...stages, ...myData]

      for (let i = 0; i < myData.length; i++) {
        const item = myData[i];
        // console.log(item.information)

        stages.push(item)

        this.findAllDropdowns(list, item._id, stages)

      }
    }
  }

  functionsHandler = (item) => {

    if (item.type == 'page') {
      this.goToPage(item)
      this.fiexView.hideView()
    }

    if (item.type == 'dropdown') {
      this.setState({ currentStage: item })
      this.stageManager.changeStage(item._id)
    }
  }

  changePageSubMenu = (title) => {
    this.stageManager.changeStage(title)
  }

  goToPage = (item) => {

    let address = item.information?.page?._id
    this.props.functionsHandler(null, 'changePage', [address])

  }


  goToPreviousStage = () => {

    this.stageManager.lastStage((newStage) => {
      if (newStage == 0) {
        this.setState({ currentStage: null })
      } else {
        let list = this.props.list
        let myData = list.filter((a) => (a._id == newStage))
        let item = myData[0]
        this.setState({ currentStage: item })
      }
    })
  }


  render() {

    let item = this.props.item
    let list = this.props.list

    return (
      <>

        {item.type == 'dropdown' && (
          <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.setting = el} onClick={() => { this.fiexView.showView() }}>
            <p className='white font-size-13' style={{ color: this.props.colors?.textColor }}>{checkTranslation(item?.information?.label)}</p>
            <img className='mld-2 invert' style={{ marginTop: 2 }} src='/assets/icons/useful/down-arrow (3).png' height={12} />
          </button>
        )}

        {item.type == 'page' && (
          <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.setting = el} onClick={() => { this.goToPage(item) }}>
            <p className='white font-size-13' style={{ color: this.props.colors?.textColor }}>{checkTranslation(item?.information?.label)}</p>
          </button>
        )}

        {item.type == 'dropdown' && (

          <FixedView width={this.props.width} zIndex={10} ref={el => this.fiexView = el} nodeRef={this.setting} xOffset={this.props.language == 'fa' ? 195 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
            <div className='bg-white br-10 p-1 shadow-3 sc-gray2'>
              {this.state.showStages && (
                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                  <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'main'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>

                    {list.filter((a) => a.parents.includes(item._id)).map((item, index) => {
                      return (
                        <IntractionActionsList key={index} onClick={() => this.functionsHandler(item)} data={{ title: item.information?.label, sub: (item.type == 'dropdown'), icon: MenuBuilderObjects[item.type]?.icon }} />
                      )
                    })}
                  </div>

                  {this.state.stages.map((stage, index) => {
                    return (
                      <div key={index} stage={1} stageName={stage._id} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                        <div className="">
                          <div className="pb-2">
                            <button className="flexc w-100 hover-gray p-2 br-10" onClick={() => this.goToPreviousStage(stage)}  >
                              <img width={18} src={importedIcons.arrowLeft} className="rtl-button" alt='' />
                              <p className="font-size-13 weight-500 mld-3 main-c3 text-start">  {checkTranslation(this.state.currentStage?.information?.label)}   </p>
                            </button>
                          </div>
                          <div className="pt-2" style={{ borderTop: "1px solid #eee" }}    >

                            {list.filter((a) => a.parents.includes(this.state.currentStage?._id)).map((item, index) => {
                              return (
                                <IntractionActionsList key={index} onClick={() => this.functionsHandler(item)} data={{ title: item.information?.label, sub: (item.type == 'dropdown'), icon: MenuBuilderObjects[item.type]?.icon }} />
                              )
                            })}
                          </div>
                        </div>
                      </div>
                    )
                  })}




                </StagesManager>
              )}
            </div>
          </FixedView>

        )}
      </>
    )
  }
}
